'use client';
import { FC } from 'react';
import { cn } from 'utils/cn';
import { RecentActivityExtended } from '..';
import ActivityLine from './ActivityLine';

interface IDashboardCards {
  activities?: RecentActivityExtended[];
}

const DashboardCards: FC<IDashboardCards> = ({ activities }) => {
  return (
    <div className="relative flex flex-col">
      <span
        className={cn(
          'absolute left-[11px] h-[calc(100%_-_100px)]',
          'mt-4 border-l-[2px] border-tertiary-800'
        )}
      />
      {activities?.map((activity, index) => (
        <ActivityLine
          key={activity.key + index}
          activity={activity}
          index={index}
          activitiesLength={activities?.length ?? 0}
        />
      ))}
    </div>
  );
};

export default DashboardCards;
